import { useState } from 'react';
import { X } from 'lucide-react';
import { shouldShowConfirmedNote, dismissConfirmedNote } from '../../lib/confirmedInBrowser';

// Shown once, on an iPhone browser, right after a sign-up confirmation link.
// Mounted beside the routes in App.js so it covers /get-verified (no AppShell)
// as well as the feed. See src/lib/confirmedInBrowser.js.
const ConfirmedInBrowserNote = () => {
  const [show, setShow] = useState(shouldShowConfirmedNote);
  if (!show) return null;

  const dismiss = () => { dismissConfirmedNote(); setShow(false); };

  return (
    <div
      className="fixed left-0 right-0 top-0 z-[60] px-4"
      style={{ paddingTop: 'calc(var(--sat) + 0.75rem)' }}
      role="status"
    >
      <div
        className="max-w-lg mx-auto rounded-xl p-3 pr-2 flex items-start gap-2 shadow-lg"
        style={{ backgroundColor: 'var(--header-bg)', border: '1px solid rgba(255,255,255,0.15)' }}
      >
        <p className="flex-1 text-sm text-white leading-snug">
          Your email is confirmed. If you signed up in the DSP Cafe app, you can head back there and pick up
          where you left off.
        </p>
        <button
          onClick={dismiss}
          aria-label="Dismiss"
          className="p-1 text-white transition-all duration-200 hover:scale-110 active:scale-95"
          style={{ opacity: 0.8 }}
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default ConfirmedInBrowserNote;
